// extracted by mini-css-extract-plugin
export default {"bottomControlsBar":"sOuCPdAZaSni9jd9JhfQ","selector":"Cr1yE4dRpSAlYWWLYOIZ","withErrorFiller":"CWloYmsJvBYkNYoaqtrz","placeHolderShimmer":"IvDFz65RBJ_LL_4XLfJd"};